import React, {useCallback} from 'react';
import {MIDI_FX} from 'constants/effect-types.js';
import EffectDropdown from '../EffectDropdown.js';
import RoutingDropdown from './RoutingDropdown.js';
import {
    effectOptions,
    ruleAuxOptions,
    midiEffectOptions,
    midiConditionalOptions,
} from '../constants.js';


export default ({
    rack,
    macrosDisabled,
    sequencerEngine,
    handleChooseEffect,
    setEdges,
    setShowMacrosView,
    selectedNodes,
    setMacros}) => {
        const addMacro = useCallback(() => {
            rack.newMacro();
            setMacros([... rack.macros]);
        }, [setMacros]);

        const connectNodes = useCallback(() => {
            rack.connectNodesInSeries(selectedNodes);
            setEdges({... rack.adjacencyLists});
        }, [setEdges, selectedNodes, rack]);
        
        let options = rack.getEffectType() === MIDI_FX ?
            midiEffectOptions : effectOptions;
        if (rack.name === "Rules Rack") {
            options = ruleAuxOptions;
        }
        if (rack.name === "Chords Rack") {
            return '';
        }
        return (
            <div className="rack-toolbar">
             <EffectDropdown
               effect={rack}
               track={rack.track}
               options={options}
               placeholder={rack.name === "Rules Rack" ? "+" : "Add FX"}
               isMidiEffect={rack.getEffectType() === MIDI_FX}
               sequencerEngine={sequencerEngine}
               handleChooseEffect={handleChooseEffect}/>
 
              {rack.getEffectType() === MIDI_FX  && rack.name !== "Rules Rack" ? 
               <EffectDropdown
                 track={rack.track}
                 isMidiEffect={rack.getEffectType() === MIDI_FX}
                 effect={rack}
                 placeholder={"Flow"}
                 options={midiConditionalOptions}
                 sequencerEngine={sequencerEngine}
                 handleChooseEffect={handleChooseEffect}/>
               : ''}
             
              {macrosDisabled ? '' :
               [(
                   <div
                     key={1}
                     onClick={addMacro}
                     className="add-macro-button">
                     Add Macro
                   </div>),
                (<div
                     key={2}
                   onClick={() => setShowMacrosView(true)}
                   className="show-macros-button">
                   Macros
                 </div>)]
              }

              {selectedNodes.length > 1 ?
               <div
                 onClick={connectNodes}
                 className="add-macro-button">Connect Nodes</div> :
               ''}
            </div>
        );
};
